







import {Component, Vue} from 'vue-property-decorator';
import HistoryBody from "@/components/history/HistoryBody.vue";
import GlobalHeader from "@/components/GlobalHeader.vue";

@Component({
    components: {HistoryBody, GlobalHeader}
})
export default class History extends Vue {}
